let back = document.getElementById("backlink");
back.href = "../index.html";

import { getContext, saveCanvas } from "./utils/ImageUtils";
let save = document.querySelector(".footer").querySelector(".button.save");
if (save != undefined) {
  save.addEventListener("pointerdown", () => {
    saveCanvas(domElement, "canvas-" + Date.now() + ".png");
  });
}

import { getContext } from "./utils/ImageUtils";
import Mouse from "./utils/Mouse";
const domElement = document.getElementById("canvas");

let w = window.innerWidth;
let h = window.innerHeight;
const mouse = new Mouse(domElement);
const ctx = getContext(w, h, domElement);

import Main from "./js/04/Main";
new Main(w, h, ctx, mouse);
